import React from "react";
import { useLanguage } from "../i18n/LanguageContext";

// Renders a translated rich-text (HTML) block; internal links get the language prefix.
export const TxHtml = ({ as: Tag = "p", html, className }) => {
  const { tx, localizePath } = useLanguage();
  const out = tx(html).replace(/href="(\/[^"]*)"/g, (_, p) => `href="${localizePath(p)}"`);
  return <Tag className={className} dangerouslySetInnerHTML={{ __html: out }} />;
};

export default TxHtml;
